// Yoga
module.exports = window.Yoga = require('./vendor/yoga-layout/entry-browser');
